module.exports = __webpack_public_path__ + "static/media/crane1.838f719d.png";